import {
  GuidIdAndLabel,
  GuidIdCodeAndLabel,
  Int32IdAndLabel,
} from "../../../integrated-client/models";

export interface IAncillariesMappingEditorData {
  id?: string | null;
  supplier?: GuidIdAndLabel;
  carrier?: GuidIdCodeAndLabel;
  ancillaryCategory?: Int32IdAndLabel;
  ancillary?: GuidIdAndLabel;
  ancillarySupplierCode?: string | null;
  effectiveFrom?: object | null;
  effectiveTo?: object | null;
  allowEdit?: boolean;
}

export interface IEditorData {
  ancillariesMappingEditorData: IAncillariesMappingEditorData;
  validation?: any;
}

export class AncillariesMappingEditorData
  implements IAncillariesMappingEditorData
{
  id?: string | null;
  supplier?: GuidIdAndLabel;
  carrier?: GuidIdCodeAndLabel;
  ancillaryCategory?: Int32IdAndLabel;
  ancillary?: GuidIdAndLabel;
  ancillarySupplierCode?: string | null;
  effectiveFrom?: object | null;
  effectiveTo?: object | null;
  allowEdit?: boolean;
}

export class EditorData implements IEditorData {
  ancillariesMappingEditorData: IAncillariesMappingEditorData;
  validation?: any;

  constructor() {
    this.ancillariesMappingEditorData = new AncillariesMappingEditorData();
  }
}
